/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import apiHome from '@/services/jApiHome';

const state = {
  attendance_detail: null,
  timesheet_detail: null,
  list_quota_leave: [],
};

const mutations = {
  setTimesheetDetail(state, data) {
    state.timesheet_detail = data;
  },
  setQuotaLeave(state, data) {
    state.list_quota_leave = data;
  },
  setAttendanceDetail(state, data) {
    state.attendance_detail = data;
  },
};

const actions = {
  async getTimesheetDetail({ commit, dispatch }, req) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const timesheetDetail = await apiHome.getTimesheetDetail(req);
      commit('setTimesheetDetail', timesheetDetail.data);
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getOrganigramId({ dispatch }, req) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      const response = await apiHome.getOrganigramId(req);
      res = response;
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      res = err;
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getQuotaLeave({ commit, dispatch }, req) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const quotaLeave = await apiHome.getQuotaLeave(req);
      commit('setQuotaLeave', quotaLeave.data);
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getAttendanceDetail({ commit, dispatch }) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const attendanceDetail = await apiHome.getAttendanceDetail();
      commit('setAttendanceDetail', attendanceDetail.data);
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreHome.js